"use client";
import GetInTouch from "../shared/form/GetInTouch";
import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { screenSizeContext } from "@/app/store/context/screenSizesContext";

const BookNowComponent = ({
	destinationData
}: any) => {
	const {isIpad} = useContext(screenSizeContext)

	const params = useSearchParams();
	const neighborhoodSlug = params.get("neighborhood");
	const unitId = params.get("unitId");
	
	const [masterplanSelectedNeighborhood, setMasterplanSelectedNeighborhood] =
		useState<string>(neighborhoodSlug || "");
	const [masterplanSelectedUnit, setMasterplanSelectedUnit] =
		useState<string>(unitId || "");

	useEffect(() => {
		if (neighborhoodSlug) {
			// console.log("Setting neighborhood:", neighborhoodSlug);
			setMasterplanSelectedNeighborhood(neighborhoodSlug);
		}
	}, [neighborhoodSlug]);

	useEffect(() => {
		if (unitId) {
			// console.log("Setting unit:", unitId);
			setMasterplanSelectedUnit(unitId);
		}
	}, [unitId]);

	return (
		<div className={` bg-oBlue-100 min-h-screen page_wrapper ${isIpad && "book-now-page"}`}>
			<GetInTouch 
				destinationData={destinationData || []} 
				masterplanSelectedNeighborhood={masterplanSelectedNeighborhood} 
				setMasterplanSelectedNeighborhood={setMasterplanSelectedNeighborhood}
				masterplanSelectedUnit={masterplanSelectedUnit}
				setMasterplanSelectedUnit={setMasterplanSelectedUnit}
				NeighborhoodsPage
				NeighborhoodsDetailsPage={!!neighborhoodSlug}
				slug={neighborhoodSlug || undefined}
			/>
		</div>
	);
};

export default BookNowComponent;
